import { call, put, select, takeLatest } from 'redux-saga/effects';
import { PICK_STEP, SUBMIT_PICKS } from './constants';
import { endPicks, submitPicks } from './actions';
import { selectPicksMade, selectPicksSource, selectPicksSteps } from './selectors';
import { picksRequest } from './steps';
import gameTurnService from '../services/gameTurn';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { closeContextMenu } from '../ActiveGame/actions';
import { selectActiveGame } from '../ActiveGame/selectors';

// The last step's pick plays the Trainer or uses the Power.
function* pickStepTask() {
  const picks = yield select(selectPicksMade);

  if (picks.size === (yield select(selectPicksSteps)).size) {
    yield put(submitPicks(yield select(selectPicksSource), picks));
  }
}

// The flow ends even when the server refuses, so the board never stays stuck waiting for a choice.
function* submitPicksTask(action) {
  const gameId = (yield select(selectActiveGame)).get('id');
  const source = action.payload.get('source');
  const picks = picksRequest(action.payload.get('picks'));

  try {
    const game = source.get('kind') === 'power'
      ? yield call(gameTurnService.power, gameId, source.get('at'), source.get('moveId'), picks)
      : yield call(gameTurnService.trainer, gameId, source.get('handPosition'), picks);
    yield call(handleUpdateGame, game);
    yield put(closeContextMenu());
  } finally {
    yield put(endPicks());
  }
}

function* pickStepWatcher() {
  yield takeLatest(PICK_STEP, pickStepTask);
}

function* submitPicksWatcher() {
  yield takeLatest(SUBMIT_PICKS, submitPicksTask);
}

export default [
  pickStepWatcher,
  submitPicksWatcher,
];
